import React from 'react';
import { Paper, makeStyles, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { uomKg, productTypeRawMaterial,productTypeAdditive, productTypePackaging,productTypeTapeFoil,productTypeUnKnown,uomPieces,uomM, bedrukken} from '../../../Config/constants'
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ShowFilesDialog from '../../Shared/Dialogs/ShowFilesDialog'
import { useState } from 'react';

export default function OrderDetailMaterials(props) {

    const classes = useStyles();

    const { t } = useTranslation();
    const [value, setValue] = React.useState(0);
    const [showFilesDialogOpen, setShowFilesDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)

    const BOMRows = props.productionOrder.bomIn.filter(x => {
        let metaData = JSON.parse(x.bomMetaData)
        return metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeAdditive || metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeRawMaterial
    }).map(m => {     

        let percentage = JSON.parse(m.bomMetaData).find(y => y.MetaDataType === 1).MetaData[0].Percentage
        return createBOMData(m.productReference, m.productDescription, m.quantityToConsume, percentage, m.productId,m.uom)
    })

    function createBOMData(code, description, quantity, percentage, productId,uom) {
        return { code, description, quantity, percentage, productId ,uom};
    }

    let bolMetaData = JSON.parse(props.productionOrder.bolMetaData).find(y => y.MetaDataType === 1).MetaData
    const BOLRows = bolMetaData.map(m => {

        let description = ""
        if (m.Description.length > 1) {
            var i;
            for (i = 0; i < m.Description.length; i++) {
                description += m.Description[i] + ", "
            }

            description = description.slice(0, -2);
        }
        else {
            description = m.Description[0]
        }

        return createBOLData(m.Name, description, m.Category)
    })

    function createBOLData(name, description, note) {
        return { name, description, note };
    }

    const PackagingRows = props.productionOrder.bomIn.filter(x => {
        let metaData = JSON.parse(x.bomMetaData)
        return metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypePackaging || metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeUnKnown || metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeTapeFoil 
    }).map(m => {

        let usagePerPallet = 0
        let totalPallets = 0
        let totalPerOrder = 0

        if (props.productionOrder.bomOut.length > 0){
            totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)

        }

        usagePerPallet = m.quantityToConsume / totalPallets

        if (usagePerPallet === 1 && m.uom === uomPieces) {
            usagePerPallet = String(usagePerPallet) + t(' PIECE')
            totalPerOrder = m.quantityToConsume + t(" PIECES")
        }
        else if(m.uom === uomPieces){
            usagePerPallet = String(usagePerPallet) + t(' PIECES')
            totalPerOrder = m.quantityToConsume + t(" PIECES")
        }
        else if(m.uom === uomM){
            usagePerPallet = String(usagePerPallet) + ' M'
            totalPerOrder = m.quantityToConsume + " M"
        }

        return createPackagingData(m.productReference, m.productDescription, usagePerPallet, totalPerOrder)
    })

    function createPackagingData(reference, description, usagePerPallet, totalPerOrder) {
        return { reference, description, usagePerPallet, totalPerOrder };
    }
/*
    function calculateWeightPercentage(weight) {

        var i;
        let totalWeight = 0;

        for (i = 0; i < props.productionOrder.bomIn.length; i++) {
            //ONLY IF UOM IS KG
            if (props.productionOrder.bomIn[i].uom === uomKg) {
                totalWeight += props.productionOrder.bomIn[i].quantityToConsume
            }
        }

        return (weight / totalWeight) * 100
    }    */

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const closeShowFilesDialog = () => {
        setShowFilesDialogOpen(false)
    }

    const openFilesPopup = () => {
        setDialogTitle(t("Printing Files"))
        setShowFilesDialogOpen(true)
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    let authorized = props.productionOrder.machineIdPlanned === props.workstation.selectedWorkstation

    return <div className={classes.orderDetailMaterials}>
        <AppBar position="static" className={classes.appBar}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="BOM" {...a11yProps(0)} className={clsx({ [classes.activeTab]: value === 0, [classes.notActiveTab]: value !== 0 })} />
                <Tab label="BOL" {...a11yProps(1)} className={clsx({ [classes.activeTab]: value === 1, [classes.notActiveTab]: value !== 1 })} />
                <Tab label={t("Packaging")} {...a11yProps(2)} style={{ textTransform: "Capitalize" }} className={clsx({ [classes.activeTab]: value === 2, [classes.notActiveTab]: value !== 2 })} />
            </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} className={classes.BOMPanel}>
            <div className={classes.head}>
                {authorized ?
                    <div className={classes.addManually}>
                        <Button className={classes.button} onClick={() => props.openMaterialCorrectionDrawer(true)}>
                            <div className={classes.addManuallyText}>
                                {'- ' + t('Correct Material')}
                            </div>
                        </Button>
                        <Button className={classes.button} onClick={() => props.openManualReplenishmentDrawer(true)}>
                            <div className={classes.addManuallyText}>
                                {'+ ' + t('Add Material')}
                            </div>
                        </Button>
                    </div> : <React.Fragment></React.Fragment>}
            </div>
            <TableContainer component={Paper} className={classes.paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>{t('Production details')}</TableCell>
                            <TableCell className={classes.headCell}>{t('Description')}</TableCell>
                            <TableCell className={classes.headCell} align="right">{t('Needed Quantity')}</TableCell>
                            <TableCell className={classes.headCell} align="right">{t('Percent')}</TableCell>
                            <TableCell className={classes.quantityAtMachineHeadCell} align="right">{t('Quantity at machine')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {BOMRows.map((row, index) => (
                            <TableRow key={row.name} className={classes.row} key={index}>
                                <TableCell className={classes.infoCell}>{row.code}</TableCell>
                                <TableCell className={classes.infoCell}>{row.description}</TableCell>
                                <TableCell className={classes.infoCell} align="right">{parseFloat(row.quantity).toFixed(3)} {row.uom.toLowerCase()}</TableCell>
                                <TableCell className={classes.infoCell} align="right">{row.percentage === undefined? "":parseFloat(row.percentage).toFixed(2) + "%"}</TableCell>
                                <TableCell className={classes.quantityAtMachineCell} align="right">{props.getQuantityAtMachine(row.productId).toFixed(3)} {row.uom.toLowerCase()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>
        <TabPanel value={value} index={1} className={classes.BOLPanel}>
            <TableContainer component={Paper} className={classes.paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>{t('Production details')}</TableCell>
                            <TableCell className={classes.headCell} style={{ width: "50%" }}>{t('Description')}</TableCell>
                            <TableCell className={classes.headCell} style={{ paddingLeft: "10px" }}>{t('Note')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {BOLRows.map((row) => (
                            <TableRow key={row.name} className={classes.row}>
                                <TableCell className={classes.infoCell}>{row.name}</TableCell>
                                <TableCell className={classes.infoCell}>{row.description}</TableCell>
                                <TableCell className={classes.infoCell}>{row.name === bedrukken && <button className={classes.showFilesButton} onClick={() => openFilesPopup()}>{t('Show files')}</button>}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <ShowFilesDialog {...props} dialogOpen={showFilesDialogOpen} action={closeShowFilesDialog} dialogTitle={dialogTitle}></ShowFilesDialog>
        </TabPanel>
        <TabPanel value={value} index={2}>
            <TableContainer component={Paper} className={classes.paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>{t('Art. N°')}</TableCell>
                            <TableCell className={classes.headCell}>{t('Description')}</TableCell>
                            <TableCell className={classes.headCell} align="right">{t('Consumption/palet')}</TableCell>
                            <TableCell className={classes.headCell} align="right">{t('Consumption/order')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {PackagingRows.map((row, index) => (
                            <TableRow key={row.name} className={classes.row} key={index}>
                                <TableCell className={classes.infoCell}>{row.reference}</TableCell>
                                <TableCell className={classes.infoCell}>{row.description}</TableCell>
                                <TableCell className={classes.infoCell} align="right">{row.usagePerPallet}</TableCell>
                                <TableCell className={classes.infoCell} align="right">{row.totalPerOrder}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>
    </div>
}

const useStyles = makeStyles({
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        width: "20%"
    },
    quantityAtMachineCell: {
        padding: "3px",
        paddingRight: "60px",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    quantityAtMachineHeadCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
        paddingRight: "60px",
        border: "none",
    },
    paper: {
        boxShadow: 'none'
    },
    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        float: "left"
    },
    addManually: {
        float: "right"
    },
    addManuallyText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        marginRight: "5px"
    },
    orderDetailMaterials: {
        padding: "20px",
        height: "auto"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
        border: "none",
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
    button: {
        padding: "0px",
        marginLeft: "10px",
        marginBottom: "10px"
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"

        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "96%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    BOMPanel: {
        "& > div": {
            paddingTop: "10px !important"
        },
    },
    BOLPanel: {
        // "& > div": {
        //     paddingTop: "10px !important"
        // },
    },
    showFilesButton: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        cursor: 'pointer',
        border: "none",
        outline: "none",
        backgroundColor: "rgb(1,1,1,0)"
    }
});